import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@totalsoft/rocket-ui';

const SimpleDialog = ({ open, onClose, size = 'md', scroll = 'body', title, content, actions, withCloseButton = false, ...rest }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={size}
      scroll={scroll}
      TransitionProps={{ exit: false }}
      closeButtonProps={withCloseButton ? undefined : { sx: { display: 'none' } }}
      fullScreen={false}
      title={title}
      content={content}
      actions={actions}
      {...rest}
    />
  );
};

SimpleDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  size: PropTypes.string,
  scroll: PropTypes.string,
  title: PropTypes.node,
  content: PropTypes.node,
  actions: PropTypes.node,
  withCloseButton: PropTypes.bool
};

export default SimpleDialog;
